import { SourcingScenarioDTO } from '@luminovo/http-client';

export function getTotalQuantity(sourcingScenario: SourcingScenarioDTO): number {
    return sourcingScenario.assembly_quantities.items.flatMap((item) => item.quantity).reduce((a, b) => a + b, 0);
}
